import { useFormContext } from '@/contexts/form-context';

export default function GeneralPanelFooter() {
  const form = useFormContext();

  return (
    <footer className="border-t border-gray-200 dark:border-gray-700/60 px-6 py-5">
      <form.Subscribe
        selector={(state) => [state.canSubmit, state.isSubmitting]}
        children={([canSubmit, isSubmitting]) => (
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={form.reset}
              className="btn border-gray-200 dark:border-gray-700/60 text-gray-800 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600 dark:bg-gray-800"
            >
              Avbryt
            </button>
            <button
              disabled={!canSubmit}
              type="submit"
              className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
            >
              {isSubmitting ? 'Sparar ändringar...' : 'Spara ändringar'}
            </button>
          </div>
        )}
      />
    </footer>
  );
}
